import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import DetailsTable from '../../TransactionsPage/DetailsTable';
import {localizationHelpers, objectHelpers, vendorsHelpers} from '../../../../utils/helpers';
import {Space} from "antd";

const VendorContactDetails = ({
  onStatusChange,
  vendor,
  ...rest
}) => {
  const [t] = useTranslation('main');

  const getObjProp = (key, defaultValue = '') => objectHelpers.getObjProp(vendor, key, defaultValue);

  const countryName = getObjProp('country');

  const data = [
    {
      key: 'name',
      label: t('name'),
      value: getObjProp('name')
    },
    {
      key: 'status',
      label: t('status'),
      value: vendorsHelpers.getVendorStatusMarkOrSelector({onChange: onStatusChange, vendor})
    },
    {
      key: 'country',
      label: t('country'),
      value: (
        <Space align='center' size='small'>
          {countryName}
          {localizationHelpers.getCountryFlagByName(countryName, { borderRadius: 5, height: 24, width: 32 })}
        </Space>
      )
    },
    {
      key: 'priority',
      label: t('priority'),
      value: t(vendorsHelpers.getVendorPriority(vendor?.priority))
    },
    {
      key: 'category',
      label: t('category'),
      value: vendorsHelpers.getVendorTags(vendor?.category)
    },
    {
      key: 'city',
      label: t('city'),
      value: getObjProp('city')
    },
    {
      key: 'address',
      label: t('address'),
      value: getObjProp('address')
    },
    {
      key: 'vat',
      label: t('vatNumber'),
      value: getObjProp('vat')
    },
    {
      key: 'contactPerson',
      label: t('contactPerson'),
      value: getObjProp('contract_person')
    },
    {
      key: 'phoneNumber',
      label: t('phoneNumber'),
      value: getObjProp('phone_number')
    },
    {
      key: 'email',
      label: t('emailAddress'),
      value: getObjProp('email')
    },
    {
      key: 'external_reference',
      label: t('externalReference'),
      value: getObjProp('accounting_external_reference')
    }
  ];

  return (
    <DetailsTable
      {...rest}
      data={data}
    />
  );
}

VendorContactDetails.propTypes = {
  vendor: PropTypes.shape({
    bic: PropTypes.string,
    iban: PropTypes.string,
  }),
}

export default VendorContactDetails;
